/** Fähigkeiten des Geräts, ohne Testpfade (ADR-0027: alles Geräteseitige stellt die Browser-Automatisierung bereit). */

/** Hat das Gerät Passkeys (WebAuthn)? (oberflaeche.md §7 Einladung, Registrierung) */
export function passkeyUnterstuetzt(): boolean {
  return typeof window.PublicKeyCredential === "function" && !!navigator.credentials;
}

/** Vorschlag für die Gerätebezeichnung aus Plattform und Browser (identitaeten.md §5), z. B. „Android-Telefon (Chrome)“. */
export function geraetebezeichnungVorschlag(): string {
  const ua = navigator.userAgent;
  const plattform = /iPhone/.test(ua) ? "iPhone" : /iPad/.test(ua) ? "iPad" : /Android/.test(ua) ? "Android-Telefon"
    : /Mac OS X/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows-PC" : "Gerät";
  const browser = /Edg\//.test(ua) ? "Edge" : /Firefox\//.test(ua) ? "Firefox" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : "Browser";
  return `${plattform} (${browser})`;
}

/**
 * iPhone, auf dem die App im Browser läuft statt vom Home-Bildschirm (LIM-0005): Dort kommen keine Benachrichtigungen
 * an; die App fragt nicht nach Zustimmung und erklärt es (oberflaeche.md §9).
 */
export function iphoneOhneHomeBildschirm(): boolean {
  const vomHomeBildschirm = (navigator as Navigator & { standalone?: boolean }).standalone === true
    || window.matchMedia("(display-mode: standalone)").matches;
  return /iPhone/.test(navigator.userAgent) && !vomHomeBildschirm;
}

/** Kann dieses Gerät Benachrichtigungen empfangen (Notification, Service Worker, Push)? */
export function benachrichtigungenMoeglich(): boolean {
  return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window && !iphoneOhneHomeBildschirm();
}

/** Vibration nach Token-Muster (design/README §7); ohne Unterstützung geschieht nichts. */
export function vibrieren(token: string): void {
  const muster = getComputedStyle(document.documentElement).getPropertyValue(`--dj-haptik-${token}`).replace(/"/g, "").trim();
  if (!muster || !("vibrate" in navigator)) return;
  navigator.vibrate(muster.split(",").map((n) => Number(n)));
}
